// hooks/useAvatar.js
import { Request } from '@group-devs/yfp7-global-modules'

const request = new Request(process.env.apiDomain)

export const useAvatar = (auth, site) => {
    const endPoint = process.env.s3EndPoint.replace('https://','');
    const bucketName = process.env.s3Bucket;
    const IMAGE_PATH = 'https://'+bucketName+'.'+endPoint;

    const contactId = auth.site_user ? auth.contactId : null
    const userId = auth.site_owner ? auth.userId : null

    const {data: profile} = request.account.swrUserProfile(userId);
    const {data: contactAccount} = request.contacts.swrAccount(contactId)
    
    const avatar = profile ? profile.avatar : (contactAccount && contactAccount.contact.profile.image != null ? IMAGE_PATH+'/'+contactAccount.contact.profile.image : null);

    return {
        avatar,
        profile,
        contactAccount
    }
}